export default __webpack_public_path__ + "dcb1947bf381a2824c71d3d56201be3d.woff2";